import {Required} from 'utility-types'
import {Dispatch, SetStateAction} from 'react'
import {omitBy, isNil} from 'lodash'

import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
  RequestResult,
} from '../../lib'

import {ITaskEventTracker} from '../../shared/db'

import {doREQUEST_ERROR, doREQUEST_COMPLETE, doMETHOD_UPDATE_TASK_EVENT_TRACKER} from '../state'
import {getToken} from './token_fetcher'
import {getTaskEventTrackerSchemaMap} from '../../model/event_tracker'

export const REQUEST_TASK_EVENT_TRACKER_UPDATE = 'REQUEST_TASK_EVENT_TRACKER_UPDATE'
export const doREQUEST_TASK_EVENT_TRACKER_UPDATE = createDoRequestAction(REQUEST_TASK_EVENT_TRACKER_UPDATE)

export const requestTaskEventTrackerUpdateActionCreators = {
  doREQUEST_TASK_EVENT_TRACKER_UPDATE,
}

interface Payload {
  payload: {
    requestId: string
    eventTracker: Required<Partial<ITaskEventTracker>, 'id'>
  }
  setRequestResult?: Dispatch<SetStateAction<RequestResult | null>>
}

export function* requestTaskEventTrackerUpdate({payload, setRequestResult}: Payload): SagaIterator {
  debug('saga*requestTaskEventTrackerUpdate')

  payload.eventTracker = omitBy(payload.eventTracker, isNil) as Payload['payload']['eventTracker']

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid().exist(),
        eventTracker: v.object(getTaskEventTrackerSchemaMap({required: ['id']})),
      }),
    })
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_EVENT_TRACKER_UPDATE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    )
  }

  const accessToken = yield call(getToken)

  const {eventTracker} = payload

  const result = yield request({
    method: 'post',
    url: `${API_URL}/v1/web/task-event-tracker-update`,
    accessToken,
    data: eventTracker,
  })

  if (!result.success || result.error) {
    const error = result.error || new Error('request did not succeed')
    debug(error)
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_TASK_EVENT_TRACKER_UPDATE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: '/v1/web/task-event-tracker-update',
          ...result,
          error,
        },
        setRequestResult,
      ),
    )
  }

  yield put(doMETHOD_UPDATE_TASK_EVENT_TRACKER(result.payload))

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_TASK_EVENT_TRACKER_UPDATE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  )
}

export function* taskEventTrackerUpdateSaga() {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  yield takeEvery(REQUEST_TASK_EVENT_TRACKER_UPDATE as any, requestTaskEventTrackerUpdate)
}
